import { createStyles, Theme, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignTop: {
      [theme.breakpoints.down('xs')]: {
        marginBottom: 63,
        '& .btn-bottom': {
          position: 'sticky',
          bottom: 0,
          left: 0,
          right: 0,
          padding: '13px',
          backgroundColor: '#fff',
          zIndex: 2,
          margin: 0,
          '& button': {
            width: '100%',
          },
        },
      },
    },
    hidden: {
      display: 'none',
    },
    infoWrapper: {
      backgroundColor: '#F7F5DA',
      padding: '15px',
      marginBottom: '32px',
      borderRadius: '4px',
      '& > a': {
        color: 'inherit',
        '&:after': {
          content: "'»'",
          display: 'inline-block',
          marginLeft: '5px',
        },
      },
    },
    partnerPromo: {
      marginTop: 32,
    },
  }),
);

export default useStyles;
